<div class="d-flex">

  <!-- <ng-container *ngIf="!newStatus && !isSoipTable">
    <span class="status-dots-main {{renderColorSpan1}} mr-2">
      <span class="status-dots {{renderColorSpan2}}"></span>
    </span>
    <span *ngIf="!showPopup" class="text-link live-feed-anch"> {{renderValue | titlecase}}</span>
    <a href="javascript:void(0)" *ngIf="showPopup" (click)="onClick()" [ngbPopover]="popContent"
      class="text-link live-feed-anch" triggers="mouseenter:mouseleave" placement="left" container="body">{{renderValue
      |
      titlecase}}</a>
  </ng-container>

  <ng-container *ngIf="newStatus && isSoipTable">
    <p [class]="statusClass === 'delivered' ? 'delivered2' : statusClass" (click)="onClick()" [ngbPopover]="popContent"
      triggers="mouseenter:mouseleave">
      {{renderValue |
      uppercase}}</p>
  </ng-container> -->

  <span class="status-dots-main {{renderColorSpan1}} mr-2">
    <span class="status-dots {{renderColorSpan2}}"></span>
  </span>
  <span *ngIf="!showPopup" class="live-feed-anch"> {{renderValue | titlecase}}</span>

  <a href="javascript:void(0)" style="text-decoration: none;" *ngIf="showPopup" (click)="onClick()"
    [ngbPopover]="popContent" class="live-feed-anch" triggers="mouseenter:mouseleave" placement="left"
    container="body">{{getStatus(renderValue) | titlecase}}</a>

</div>
<ng-template #popContent>

  <div class="overlay-status" *ngIf="isSoipTable==='email'">
    <div class="overlay-status-server-remark" *ngIf="rowData.subject!==''">
      Subject: {{rowData.subject}}
    </div>
    <!-- overlay-status -->
    <div class="overlay-status-inner">
      <ul class="custom-css-wizard">
        <li class="sent" class="request">
          <div><span>Request</span>
            <br /><i class="icon-email-sent request"></i><br />
            <strong class="date-time">{{rowData.atime}}</strong>
          </div>
        </li>

        <li class="sent" [class.enable]="rowData.description.toLowerCase() === 'dropped' ||
                            rowData.description.toLowerCase() === 'invalid' ||
                            rowData.description.toLowerCase() === 'processing' ||
                            rowData.description.toLowerCase() === 'delivered' ||
                            rowData.description.toLowerCase() === 'cancelled' ||
                            rowData.description.toLowerCase() === 'hard bounced'"
          [ngClass]="rowData.description.toLowerCase() ==='clicked' || rowData.description.toLowerCase() === 'delivered' || rowData.description.toLowerCase() === 'opened' || rowData.description.toLowerCase() === 'unsubscribed' || rowData.description.toLowerCase() === 'reported spam' || rowData.description.toLowerCase() === 'cancelled' ? getStatusClass(rowData.description) : rowData.description.toLowerCase().split(' ').join('')">
          <div>
            <span *ngIf="rowData.description.toLowerCase() === 'clicked'">Delivered</span>
            <span *ngIf="rowData.description.toLowerCase() === 'opened'">Delivered</span>
            <span *ngIf="rowData.description.toLowerCase() === 'delivered'">Delivered</span>
            <span *ngIf="rowData.description.toLowerCase() === 'unsubscribed'">Delivered</span>
            <span *ngIf="rowData.description.toLowerCase() === 'soft bounced'"> {{rowData.description | titlecase}}
            </span>
            <span *ngIf="rowData.description.toLowerCase() === 'failed'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'reported spam'">Delivered</span>
            <span *ngIf="rowData.description.toLowerCase() === 'cancelled'">Scheduled</span>
            <span *ngIf="rowData.description.toLowerCase() === 'bounced'"> {{rowData.description | titlecase}} </span>
            <span *ngIf="rowData.description.toLowerCase() === 'dropped'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'processing'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'invalid'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'hard bounced' ">{{rowData.description |
              titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'scheduled' ">{{rowData.description | titlecase}}</span>
            <!-- <span *ngIf="rowData.description.toLowerCase() === 'cancelled' ">{{rowData.description | titlecase}}</span> -->
            <br />
            <i class="icon-email-sent"
              [ngClass]="rowData.description.toLowerCase() ==='clicked' || rowData.description.toLowerCase() === 'delivered' || rowData.description.toLowerCase() === 'opened' || rowData.description.toLowerCase() === 'unsubscribed' || rowData.description.toLowerCase() === 'reported spam' || rowData.description.toLowerCase() === 'cancelled' ? getStatusClass(rowData.description) : rowData.description.toLowerCase().split(' ').join('')"></i>
            <br />
            <strong *ngIf="rowData.description.toLowerCase() === 'clicked'"
              class="date-time">{{rowData.clicktime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'opened'"
              class="date-time">{{rowData.clicktime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'delivered'"
              class="date-time">{{rowData.clicktime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'unsubscribed'"
              class="date-time">{{rowData.clicktime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'soft bounced'"
              class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'reported spam'"
              class="date-time">{{rowData.clicktime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'bounced'" class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'dropped'" class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'processing'"
              class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'invalid'" class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'hard bounced'"
              class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'scheduled'"
              class="date-time">{{rowData.sch_time}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'cancelled'"
              class="date-time">{{rowData.sch_time}}</strong>
          </div>
        </li>
        <!--li class="sent" [hidden]="rowData.description.toLowerCase() === 'invalid' || rowData.description.toLowerCase() === 'processed' || rowData.description.toLowerCase() === 'sent' || rowData.description.toLowerCase() === 'hard bounce' " [class.enable]="rowData.description.toLowerCase() === 'sent' || rowData.description.toLowerCase() === 'click' " -->
        <li class="second {{rowData.description.toLowerCase().split(' ').join('')}}" [hidden]="rowData.description.toLowerCase() === 'dropped' ||
                      rowData.description.toLowerCase() === 'invalid' ||
                      rowData.description.toLowerCase() === 'processing' ||
                      rowData.description.toLowerCase() === 'delivered' ||
                      rowData.description.toLowerCase() === 'hard bounced' ||
                      rowData.description.toLowerCase() === 'soft bounced' ||
                      rowData.description.toLowerCase() === 'scheduled' ||
                      rowData.description.toLowerCase() === 'bounced' ">
          <div><span>{{rowData.description | titlecase}}</span>
            <!--br/><i class="icon-email-bounded"></i><br/-->
            <br /><i class="icon-email-sent second {{rowData.description.toLowerCase().split(' ').join('')}}"></i><br />
            <strong *ngIf="rowData.description.toLowerCase() !== 'cancelled'"
              class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'cancelled'"
              class="date-time">{{rowData.csch_time}}</strong>
          </div>
        </li>

        <li class="last">
          <span class="status-size">
            <i class="icon-email"></i><br />
            <strong>{{rowData.msize}}</strong>
          </span>
        </li>

      </ul>
    </div>
    <div class="overlay-status-server-remark">
      {{rowData.remarks}}
    </div>
  </div>

  <div class="overlay-status" *ngIf="isSoipTable==='rcs'">
    <div class="overlay-status-server-remark" *ngIf="rowData.campaign!==''">
      Campaign name : {{rowData.campaign}}
    </div>
    <!-- overlay-status -->
    <div class="overlay-status-inner">
      <ul class="custom-css-wizard">
        <li class="sent" [class.enable]="">
          <div><span>Request</span>
            <br /><i class="icon-email-sent"></i><br />
            <strong class="date-time">{{rowData.atime}}</strong>
          </div>
        </li>

        <li class="sent" [class.enable]="rowData.description.toLowerCase() === 'processing' ||
                            rowData.description.toLowerCase() === 'sent' ||
                            rowData.description.toLowerCase() === 'delivered' ||
                            rowData.description.toLowerCase() === 'failed' ||
                            rowData.description.toLowerCase() === 'read' ||
                            rowData.description.toLowerCase() === 'clicked' ">
          <div *ngIf="rowData.description.toLowerCase() !== 'not sent'">
            <span *ngIf="rowData.description.toLowerCase() === 'processing'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'sent'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'delivered'">Delivered</span>
            <span *ngIf="rowData.description.toLowerCase() === 'failed'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'read' || rowData.description.toLowerCase() === 'clicked'">
              Delivered
            </span>

            <br /><i class="icon-email-sent"></i><br />

            <strong *ngIf="rowData.description.toLowerCase() === 'processing'"
              class="date-time">{{rowData.itime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'sent'" class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'delivered'"
              class="date-time">{{rowData.dtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'failed'" class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'read' || rowData.description.toLowerCase() === 'clicked'"
              class="date-time">{{rowData.dtime}}</strong>

          </div>
        </li>

        <li class="sent enable" [hidden]=" rowData.description.toLowerCase() === 'processing' ||
                          rowData.description.toLowerCase() === 'sent' ||
                          rowData.description.toLowerCase() === 'delivered' ||
                          rowData.description.toLowerCase() === 'failed' ">
          <div><span>{{rowData.description | titlecase}}</span>
            <br /><i class="icon-email-sent"></i><br />
            <strong class="date-time">{{rowData.mtime}}</strong>
          </div>
        </li>

        <li class="last">
          <span class="status-size">
          </span>
        </li>

      </ul>
    </div>
    <div *ngIf="rowData.remarks != ''" class="overlay-status-server-remark">
      Remarks : {{rowData.remarks}}
    </div>
  </div>

  <div class="overlay-status" *ngIf="isSoipTable==='deflector'">
    <div class="overlay-status-server-remark" >
      <!-- *ngIf="rowData.campaign!==''" -->
      <!-- Campaign name : {{rowData.campaign}} -->
    </div>
    <!-- overlay-status -->
    <div class="overlay-status-inner">
      <ul class="custom-css-wizard">
        <li class="sent" [class.enable]="">
          <div><span>Request</span>
            <br /><i class="icon-email-sent"></i><br />
            <strong class="date-time">{{rowData.atime}}</strong>
          </div>
        </li>

        <li class="sent" [class.enable]="rowData.description.toLowerCase() === 'processing' ||
                            rowData.description.toLowerCase() === 'sent' ||
                            rowData.description.toLowerCase() === 'delivered' ||
                            rowData.description.toLowerCase() === 'failed' ||
                            rowData.description.toLowerCase() === 'read' ">
          <div *ngIf="rowData.description.toLowerCase() !== 'not sent'">
            <span *ngIf="rowData.description.toLowerCase() === 'processing'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'sent'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'delivered'">Delivered</span>
            <span *ngIf="rowData.description.toLowerCase() === 'failed'">{{rowData.description | titlecase}}</span>
            <span *ngIf="rowData.description.toLowerCase() === 'read'"> Delivered </span>
            <span *ngIf="rowData.description.toLowerCase() === 'clicked'"> Delivered </span>

            <br /><i class="icon-email-sent"></i><br />

            <strong *ngIf="rowData.description.toLowerCase() === 'processing'"
              class="date-time">{{rowData.itime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'sent'" class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'delivered'"
              class="date-time">{{rowData.dtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'failed'" class="date-time">{{rowData.mtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'read'" class="date-time">{{rowData.dtime}}</strong>
            <strong *ngIf="rowData.description.toLowerCase() === 'clicked'" class="date-time">{{rowData.dtime}}</strong>

          </div>
        </li>

        <li class="sent enable" [hidden]=" rowData.description.toLowerCase() === 'processing' ||
                          rowData.description.toLowerCase() === 'sent' ||
                          rowData.description.toLowerCase() === 'delivered' ||
                          rowData.description.toLowerCase() === 'failed' ">
          <div><span>{{rowData.description | titlecase}}</span>
            <br /><i class="icon-email-sent"></i><br />
            <strong class="date-time">{{rowData.mtime}}</strong>
          </div>
        </li>

        <li class="last">
          <span class="status-size">
          </span>
        </li>

      </ul>
    </div>
    <div *ngIf="rowData.remarks != ''" class="overlay-status-server-remark">
      Remarks : {{rowData.remarks}}
    </div>

  </div>

</ng-template>